import React from 'react';
import {IShopifyData} from '../types';

interface SimpleSubInfoProps {
  shopifyData: IShopifyData;
}

const SimpleSubInfo: React.FunctionComponent<SimpleSubInfoProps> = ({shopifyData}: SimpleSubInfoProps) => {
  const { infoSettings } = shopifyData.settings;

  return (
    <div className="simple-sub-info-wrap">
      <div className="simple-sub-info">
        <img className="simple-sub-info-img" src={infoSettings.mainImgUrl} width={500} height={333} />

        <div className="simple-sub-info-main">
          <ul className="simple-sub-info-items">
            {infoSettings.infoItems.map((item, idx) => {
              return (
                <li key={idx} className='simple-sub-info-item'>
                  <span className='simple-sub-info-item-icon' dangerouslySetInnerHTML={{__html: item.icon }} />
                  <div>
                    <h5 className='simple-sub-info-item-title'>{item.title}</h5>
                    <p className='simple-sub-info-item-subtitle'>{item.subtitle}</p>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="simple-sub-info-review">
          <img src={infoSettings.reviewStarsUrl} width={80} height={15}/>
          <span className='simple-sub-info-review-txt'>{infoSettings.reviewTxt}</span>
          <img src={infoSettings.reviewLogoUrl} width={78} height={20}/>
        </div>
      </div>
    </div>
  );
};

export default SimpleSubInfo;